import { render, staticRenderFns } from "./ExaminationJg.vue?vue&type=template&id=683852ee&scoped=true"
import script from "./ExaminationJg.vue?vue&type=script&lang=js"
export * from "./ExaminationJg.vue?vue&type=script&lang=js"
import style0 from "./ExaminationJg.vue?vue&type=style&index=0&id=683852ee&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "683852ee",
  null
  
)

export default component.exports